import React, { useEffect, useState } from "react";
import { loadImage } from "../../../../../../../common-deprecated/utils";
import Debug from "../../../../../../../common-deprecated/Debug";
import * as Image from "../../../../../../../common-deprecated/styles/toyota/Image";
import IconPlaceholder from "../../../../../../../common-deprecated/svg/toyota/aem/placeholder-accessories.svg";
import { getCarDBAssetSrcSet } from "../../../../../../shared-logic/utils/imageUtils";
import { useBnbSelector } from "../../../../redux/store";

type ExtraImageType = {
    src: string;
    altTag: string;
};

const ExtraImage = ({ src, altTag }: ExtraImageType): JSX.Element => {
    const settings = useBnbSelector((state) => state.commonSettings);
    const [imageLoaded, setImageLoaded] = useState<boolean>(false);
    const [loadFailed, setLoadFailed] = useState<boolean>(false);

    useEffect(() => {
        const imageLoader = async (): Promise<void> => {
            try {
                await loadImage(src);
                setImageLoaded(true);
            } catch (ex) {
                setLoadFailed(true);
                Debug.error(`Failed to load image: ${src}`);
            }
        };

        if (!imageLoaded && !loadFailed && src) imageLoader();
    }, [imageLoaded, loadFailed, src]);

    return (
        <Image.Wrapper square>
            {(loadFailed || !imageLoaded) && <IconPlaceholder />}
            {imageLoaded && (
                <Image.Fluid
                    {...getCarDBAssetSrcSet(
                        settings,
                        [
                            { width: 512, height: 512 },
                            { width: 254, height: 254 },
                        ],
                        src,
                    )}
                    loading="lazy"
                    width="512"
                    height="512"
                    sizes="(max-width: 576px) 512px, 254px"
                    fadeInAnimation
                    alt={altTag}
                />
            )}
        </Image.Wrapper>
    );
};

export default ExtraImage;
